import {
  show,
  fetchAll,
  inactivate,
} from '@/services/defaultServiceValues/defaultServiceValuesService'

const state = {
  defaultServiceValue: {},
  defaultServiceValues: [],
  isDefaultServiceValueLoading: false,
}

const getters = {
  defaultServiceValue: (state) => state.defaultServiceValue,
  defaultServiceValues: (state) => state.defaultServiceValues,
  isDefaultServiceValueLoading: (state) => state.isDefaultServiceValueLoading,
}

const actions = {
  async fetchDefaultServiceValue({ commit }, defaultServiceValue) {
    commit('setDefaultServiceValueLoading', true)

    try {
      const { data } = await show(defaultServiceValue)
      commit('setDefaultServiceValue', data)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setDefaultServiceValueLoading', false)
    }
  },

  async fetchDefaultServiceValues({ commit, dispatch, rootState }) {
    commit('setIsLoading', true)

    const defaultParams = {
      size: rootState.paginate.itemsPerPage,
      page: rootState.paginate.currentPage - 1,
    }

    const params = {
      active: true,
      ...defaultParams,
      ...rootState.filters.filters,
    }

    try {
      const { data } = await fetchAll(params)
      const { result, total } = await data

      commit('setDefaultServiceValues', result)
      commit('setTotalPages', total)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },

  async inactivateDefaultServiceValue({ commit, dispatch }) {
    commit('setIsLoading', true)

    try {
      await inactivate([state.defaultServiceValue.id])

      commit('closeAllModals')
      commit('setDefaultServiceValue', {})
      dispatch('fetchDefaultServiceValues')
      dispatch(
        'showSuccessMessage',
        'Valor Padrão de Serviço inativado com sucesso.'
      )
    } catch ({ data }) {
      dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsLoading', false)
    }
  },
}

const mutations = {
  setDefaultServiceValue(state, defaultServiceValue) {
    state.defaultServiceValue = defaultServiceValue
  },

  setDefaultServiceValues(state, defaultServiceValues) {
    state.defaultServiceValues = defaultServiceValues
  },

  setDefaultServiceValueLoading(state, status) {
    state.isDefaultServiceValueLoading = status
  },
}

export default {
  state,
  mutations,
  actions,
  getters,
}
